import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';

const EXPERIMENT = 'car-merch-ui-vdp-mini-hero';

export default function useTrackMiniHeroRendered(): void {
  useTrackRendered(EXPERIMENT);
}
